import { render, staticRenderFns } from "./RatingDirectionsStat.vue?vue&type=template&id=3c514beb"
import script from "./RatingDirectionsStat.vue?vue&type=script&lang=js"
export * from "./RatingDirectionsStat.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports